import React from 'react';

const NewReportsContainerV2 = React.lazy(() => import('../../Containers/ReportsContainer/NewReportsContainerV2'));

const NewReportsV2 = () => {
	return (
		<NewReportsContainerV2 />
	);
};

export default NewReportsV2;
